<template>
    <v-dialog :value="value"
              @input="toggleModal()"
              max-width="600px"
              persistent>
        <v-card>
            <v-toolbar color="kbGold" dark flat text>
                <v-toolbar-title>{{ $t('general.importAssistants') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal()">
                    <v-icon>
                        clear
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="valid" ref="importerForm" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-select :label="$t('general.event')"
                                      color="kbDarkBlue"
                                      :items="events"
                                      item-text="title"
                                      v-model="event"
                                      return-object
                                      :rules="[rules.required]"
                                      @change="updateTickets()">
                            </v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select label="Ticket"
                                      color="kbDarkBlue"
                                      :items="event ? event.tickets : []"
                                      :disabled="!event"
                                      item-text="title"
                                      v-model="ticket"
                                      return-object
                                      :rules="[rules.required]">
                            </v-select>
                        </v-col>

                        <v-col cols="12" class="font-weight-bold text-center pa-4" >
                            {{file && file.name || $t('general.noFilePicked')}}
                        </v-col>

                        <input type="file" style="display: none" ref="fileInput" accept=".csv,.xlsx,xls" @change="onFilePicked">

                        <v-col class="text-center" cols="12" >
                            <v-btn @click="onPickFile()"
                                   color="kbGold"
                                   dark
                                   large>
                                {{ $t('general.pickFile') }}
                                <v-icon right>
                                    insert_drive_file
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn color="kbDarkBlue"
                       outlined
                       @click="downloadFormatImporter()"
                       :loading="downloadingFormatImporter">
                    {{ $t('general.downloadFormat') }}
                </v-btn>
                <v-spacer/>
                <v-btn class="mr-2" outlined color="red" @click="toggleModal()">{{ $t('general.cancel') }}</v-btn>
                <v-btn color="kbGold"
                       dark
                       @click="importAttendees()"
                       :loading="importingAttendees">
                    {{ $t('general.import') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      events: state => state.events.events
    })
  },
  data () {
    return {
      downloadingFormatImporter: false,
      importingAttendees: false,
      event: '',
      file: '',
      rules,
      ticket: '',
      valid: true
    }
  },
  methods: {
    async downloadFormatImporter () {
      this.downloadingFormatImporter = true
      const link = document.createElement('a')
      link.href = 'https://storage.googleapis.com/keybe/app/files/import_attendess.xlsx'
      link.setAttribute('download', `${this.$t('general.format')}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.downloadingFormatImporter = false
    },
    importAttendees () {
      if (!this.$refs.importerForm.validate()) return
      if (!this.file) return notifications.error(this.$t('general.pickFile'))
      this.importingAttendees = true
      this.$store.dispatch('importAttendees', { eventId: this.event._id, ticketId: this.ticket._id, file: this.file }).then(() => {
        notifications.success(this.$t('general.assistantsImportedSuccessfully'))
        this.importingAttendees = false
        this.toggleModal()
      }).catch(error => {
        notifications.error(error.message)
        this.importingAttendees = false
      })
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const file = event.target.files[0]
      this.$set(file, 'status', 'pending')
      this.file = file
      event.target.value = ''
    },
    toggleModal () {
      this.file = ''
      this.$refs.importerForm.reset()
      this.$emit('input', false)
    },
    updateTickets () {
      if (!this.event) return
      this.ticket = ''
    }
  },
  props: ['selectedEvent', 'value']
}
</script>
